import request from './adminRequest'

export const userApi = {
  listUser (params) {
    return request.get('/users', { params: params })
  },
  getUser (uid) {
    return request.get('/users/' + uid)
  },
  updateUser (uid, data) {
    return request.put('/users/' + uid, data)
  },
  updateUserType (uid, data) {
    return request.put('/users/userType/' + uid, data)
  },
  deleteUser (uid) {
    return request.delete('/users/' + uid)
  },
}
export default userApi
